import { Alert, Autocomplete, Grid, Skeleton, TextField } from '@mui/material';
import { styled } from '@mui/system';

// Icons
import EastIcon from '@mui/icons-material/East';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ReportGmailerrorredIcon from '@mui/icons-material/ReportGmailerrorred';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

// CHANGE PLACEHOLDER INPUTS
export const RenamedValueInput = styled(TextField)(({ theme }) => ({
  '& .MuiInputBase-root.Mui-disabled': {
    backgroundColor: theme.palette.action.hover,
    color: theme.palette.text.primary,
  },
}));

export const OpenInNew = styled(OpenInNewIcon)(({ margin }) => ({
  width: '14px',
  height: 'auto',
  marginRight: '6px',
}));

export const BoldText = styled('span')({
  fontWeight: 'bold',
});

export const SourceItem = styled('div')(({ theme }) => ({
  width: 'fit-content',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: '14px',
  color: theme.palette.info.main,
  '&:hover': {
    cursor: 'pointer',
  },
}));

// FIX BROKEN PLACEHOLDERS
export const TopText = styled('span')({
  lineHeight: '19px',
  fontWeight: 400,
});

// MAPPING TABLE
export const TopTitle = styled('span')({
  fontWeight: 'bold',
});

// REMAP ROW
export const BrokenPlaceholder = styled('div')(({ theme }) => ({
  border: `1px solid ${theme.palette.error.main}`,
  backgroundColor: theme.palette.background.paper,
  color: theme.palette.error.main,
  padding: '1px 4px',
  borderRadius: '4px',
  width: 'fit-content',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

export const Right = styled(EastIcon)({
  height: '20px',
  width: 'auto',
  fontWeight: 'bold',
});

export const CenterGrid = styled(Grid)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

// RENAME PLACEHOLDERS DIALOG
export const DropdownLabel = styled('div')({
  marginBottom: '8px',
  marginTop: '4px',
  lineHeight: '19px',
});

// RENAME SOURCE AND REFERENCES
export const Label = styled('div')({
  marginBottom: '8px',
  lineHeight: '19px',
});

export const StyledAlert = styled(Alert)(({ theme, borderColor, bgColor }) => ({
  border: `1px solid ${borderColor}`,
  background: bgColor,
  color: theme.palette.text.primary,
}));


export const StyledAutocomplete = styled(Autocomplete)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
}));

export const StyledSkeleton = styled(Skeleton)(({ theme, width, height, margin, borderRadius }) => ({
  borderRadius: borderRadius ? borderRadius : '4px',
  background: theme.palette.divider,
  width: '100%',
  height: height,
  margin: margin,
}));

// SHOW PH REPLACE //
export const Arrow = styled(ArrowDownwardIcon)({
  height: '20px',
  width: 'auto',
});

export const Error = styled(ReportGmailerrorredIcon)(({ theme }) => ({
  height: '20px',
  width: 'auto',
  color: theme.palette.error.main,
}));

export const CustomGrid = styled(Grid)(({ margin, horizontal, vertical }) => ({
  margin: margin,
  ...(horizontal &&
    vertical && { display: 'flex', alignItems: vertical, justifyContent: horizontal }),
}));

export const ReplacedItem = styled(Grid)(({ theme, showLine }) => ({
  backgroundColor: theme.palette.action.hover,
  padding: '12px 8px',
  borderRadius: '4px',
  textDecoration: showLine ? 'line-through' : 'none',
}));

export const ReferencedText = styled('span')(({ theme }) => ({
  lineHeight: '16px',
  color: theme.palette.text.secondary,
}));
